import { Link } from "react-router-dom";
import type { ComicItem } from "@/mocks/comics";

export default function ComicCard({ comic, featured = false }: { comic: ComicItem; featured?: boolean }) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200/70 bg-background-100/70 transition-all hover:-translate-y-1"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title} 韩国妖精漫画封面`}
          title={`${comic.title} 妖精漫画`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute left-2 top-2 flex items-center gap-1 rounded-md bg-background-50/85 px-2 py-1 text-xs font-medium text-primary-500 backdrop-blur">
          <i className="ri-star-fill text-primary-500"></i>
          {comic.rating.toFixed(1)}
        </div>
        {comic.status === "已完结" && (
          <span className="absolute right-2 top-2 rounded-md bg-accent-500 px-2 py-1 text-xs font-medium text-background-50">
            已完结
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-background-50/90 to-transparent" />
      </div>
      <div className={`p-3 ${featured ? "md:p-4" : ""}`}>
        <h3 className={`font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors ${featured ? "text-base" : "text-sm"}`}>
          {comic.title}
        </h3>
        <p className={`mt-1 flex items-center justify-between text-foreground-600 ${featured ? "text-sm" : "text-xs"}`}>
          <span className="text-accent-700">{comic.category}</span>
          <span>共 {comic.chapters} 话</span>
        </p>
        <p className={`mt-1.5 text-foreground-600 ${featured ? "text-sm" : "text-xs"}`}>
          <span className="text-foreground-500">更新：</span>
          {comic.update}
        </p>
      </div>
    </Link>
  );
}